import _ from "@lodash";
import { Divider, Paper, Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import classNames from "classnames";
import clsx from "clsx";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import XAPPButton from "../Button/XAPPButton";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        "& .ReactTable .rt-thead .rt-th.-sort-asc": {
            boxShadow: "none"
        },
        "& .ReactTable .rt-thead .rt-td.-sort-asc": {
            boxShadow: "none"
        }
    },
    selected: {
        backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)"
    },
    toolbar: {
        background: theme.palette.type === "dark" ? "#303030" : "#E6E6E6",
        borderRadius: "4px 4px 0 0",
        minHeight: 44
    },
});

class DashboardFuncionalidade extends XAPPComponent {

    state = {
        tabValue: 0,
    };

    getDados = () => {
        const { data, agrupador, conteudo } = this.props;
        var AResponse = {};
        var ATotal = 0;
        if (!_.isUndefined(data) && !_.isNull(data)) {
            data.forEach(item => {
                if (!_.isNull(item[agrupador])) {
                    var AProp = item[agrupador];
                    // eslint-disable-next-line no-prototype-builtins
                    if (AResponse.hasOwnProperty(AProp)) {
                        AResponse[AProp] += item[conteudo];
                    }
                    else {
                        AResponse[AProp] = item[conteudo];
                    }
                    ATotal += item[conteudo];
                }
            });
        }
        Object.keys(AResponse).forEach(key => {
            AResponse[key + "_perc"] = Number.parseFloat(((AResponse[key] / ATotal) * 100).toFixed(2));
        });

        return AResponse;
    };

    AdapterValue = (_ADados) => {
        var ALabels = [];
        var AData = [];

        Object.keys(_ADados).forEach(key => {
            if (!key.includes("_perc")) {
                ALabels.push(key + ": " + _ADados[key + "_perc"] + "% ");
                AData.push(_ADados[key]);
            }
        });

        return {
            labels: ALabels,
            data: AData,
            change: [0, 0]
        };
    };

    getValorTotal = () => {
        const { data, agrupador, conteudo } = this.props;
        var AResponse = 0;
        if (!_.isUndefined(data) && !_.isNull(data)) {
            data.forEach(item => {
                if (!_.isNull(item[agrupador]) && !_.isNaN(item[agrupador])) {
                    if (agrupador === "naturezadescricao") {
                        AResponse += ((item["naturezadescricao"]).toLowerCase() === "pagar" ? (-1 * item[conteudo]) : item[conteudo]);
                    }
                    else {
                        AResponse += item[conteudo];
                    }
                }
            });
        }
        return AResponse;
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({ tabValue });
    };

    getIconGraficos = () => {
        const { funcionalidade, classes } = this.props;
        const form = this.state;

        switch (funcionalidade) {
            case "extrato":
            case "contaspagar":
            case "contasreceber":
                return (
                    <React.Fragment>
                        <XAPPButton
                            tooltip={{ "title": "Card", "placement": "top" }}
                            type="Icon"
                            className={clsx("p-8", form.tabValue === 1 && classes.selected)}
                            variant="contained"
                            color="action"
                            onClick={(ev) => this.handleChangeTab(ev, 1)}
                            iconProps={"justify-center text-20"}
                            icon={"card_text"}
                        />
                        <XAPPButton
                            tooltip={{ "title": "Gráfico", "placement": "top" }}
                            type="Icon"
                            className={clsx("p-8", form.tabValue === 2 && classes.selected)}
                            variant="contained"
                            color="action"
                            onClick={(ev) => this.handleChangeTab(ev, 2)}
                            iconProps={"justify-center text-20"}
                            icon={"graph"}
                        />
                    </React.Fragment>
                );
            case "contas":
                return (
                    <React.Fragment>
                        <XAPPButton
                            tooltip={{ "title": "Card", "placement": "top" }}
                            type="Icon"
                            className={clsx("p-8", form.tabValue === 1 && classes.selected)}
                            variant="contained"
                            color="action"
                            onClick={(ev) => this.handleChangeTab(ev, 1)}
                            iconProps={"justify-center text-20"}
                            icon={"card_text"}
                        />
                    </React.Fragment>
                );
        }
    };

    render() {
        const { data = null, classes, theme, children } = this.props;
        const form = this.state;
        const ADados = this.getDados();
        const AGrafico = this.AdapterValue(ADados);

        return (
            <React.Fragment>
                <div className={clsx(classes.toolbar, "w-full flex flex-row justify-start items-center pl-16")}>
                    {!_.isNull(data) && data.length > 0 &&
                        <React.Fragment>
                            {this.getIconGraficos()}
                            {form.tabValue !== 0 &&
                                <XAPPButton
                                    tooltip={{ "title": "Fechar", "placement": "top" }}
                                    type="Icon"
                                    className={clsx("p-8")}
                                    variant="contained"
                                    color="action"
                                    onClick={(ev) => this.handleChangeTab(ev, 0)}
                                    iconProps={"justify-center text-20"}
                                    icon={"close"}
                                />
                            }
                            <Divider className="h-24 w-px" />
                        </React.Fragment>
                    }
                    {children}
                </div>
                {form.tabValue === 2 &&
                    <div className="flex flex-wrap justify-center">
                        <div className="h-224 w-full text-center justify-center">
                            <Doughnut
                                data={{
                                    labels: AGrafico.labels,
                                    datasets: [{
                                        ...AGrafico,
                                        borderColor: this.props.theme.palette.divider,
                                        backgroundColor: [
                                            "#C3BBA6",
                                            "#AEA489",
                                            "#B1B2A4",
                                            "#8A8D7C",
                                            "#585858",
                                            "#353D40",
                                            "#201C19",
                                        ],
                                        hoverBackgroundColor: [
                                            "#D3D3D3",
                                            "#D3D3D3",
                                            "#D3D3D3",
                                            "#D3D3D3",
                                            "#D3D3D3",
                                            "#D3D3D3",
                                            "#D3D3D3",
                                        ]
                                    }]
                                }}
                                options={{
                                    cutoutPercentage: 75,
                                    spanGaps: false,
                                    legend: {
                                        display: true,
                                        labels: {
                                            fontColor: theme.palette.type === "dark" ? "#f2f2f2" : "#666"
                                        }
                                    },
                                    maintainAspectRatio: false
                                }}
                            />
                        </div>
                    </div>
                }
                {form.tabValue === 1 &&
                    <div className="flex overflow-x-auto overflow-y-hidden">
                        <Paper className={classNames("rounded-8 border-1 m-8 min-w-192 w-192 max-w-192")}>
                            <div className="text-center py-12">
                                <div className="w-full justify-center items-center flex flex-row mb-12">
                                    <Typography className="text-12" color="textSecondary">{"Total"}</Typography>
                                </div>
                                <Typography className={"text-20 leading-none"}>{"R$ " + this.getValorTotal().toFixed(2)}</Typography>
                            </div>
                        </Paper>
                        {Object.keys(ADados).map((key, x) => {
                            if (!key.includes("_perc")) {
                                return (
                                    <Paper key={x} className={classNames("rounded-8 border-1 m-8 min-w-192 w-192 max-w-192")}>
                                        <div className="text-center py-12">
                                            <div className="w-full justify-center items-center flex flex-row mb-12">
                                                <Typography className="text-12" color="textSecondary">{key}</Typography>
                                            </div>
                                            <Typography className={"text-20 leading-none"}>{"R$ " + (!_.isNull(ADados[key]) && _.isNumber(ADados[key]) ? ADados[key].toFixed(2) : "0.00")}</Typography>
                                        </div>
                                    </Paper>
                                );
                            }
                        })}
                    </div>
                }
            </React.Fragment>
        );
    }
}

function mapStateToProps({ fuse }) {
    return {
        theme: fuse.settings.mainTheme
    };
}

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(DashboardFuncionalidade)));
